module.exports = __webpack_public_path__ + "img/highlights2.62d654da.png";